<template>
	<div v-if="$route.name!='system'" class="system">
		<div class="header">
			<el-menu router :default-active="$route.name" mode="horizontal">
				<el-menu-item index="system_region" :route="{name:'system_region'}">区域管理</el-menu-item>
				<el-menu-item index="system_config" :route="{name:'system_config'}">系统参数</el-menu-item>
			</el-menu>
		</div>
		<router-view ref="systemCallback"></router-view>
	</div>
</template>

<script>
	export default {
		created() {
			this.resetRoute();
		},
		methods: {
			resetRoute(){
				const that = this;
				if (that.$route.name == 'system') {
					that.$router.push({
						name: 'system_region'
					});
				}
			}
		},
		watch: {
			$route: {
				handler: 'resetRoute'
			}
		}
	}
</script>
